<template>
    <div>
        <v-progress-circular
                indeterminate
                color="red"
        ></v-progress-circular>
        <p>{{loadingText}}</p>
    </div>
</template>
<script>
    export default {
        props: ['loadingText']
    }
</script>